import { faEye } from "@fortawesome/pro-light-svg-icons"
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome"
import { DocumentoComercialValidacionDtoProps } from "api/DTOs/DocumentoComercialValidacionDto"
import { TFunction } from "i18next"
import { Dispatch, SetStateAction } from "react"
import { frontendCurrency } from "utils/formatCurrency"
import { frontendDateFormat } from "utils/formatDate"

export const DOCUMENTOS_DETALLE_COLUMNS = (
  t: TFunction,
  setRowSelected: Dispatch<SetStateAction<string | undefined>>
) => {
  const columns = [
    {
      key: "serie",
      header: `${t("documentos.validar.tab.headerNum")}`,
      field: "serie",
      body: (rowData: DocumentoComercialValidacionDtoProps) =>
        rowData?.serie?.length === 1 && rowData?.numero
          ? `${rowData?.serie}${rowData?.numero?.toString().padStart(4, "0")}`
          : rowData?.serie,
      className: "tw-text-base tw-text-text",
    },
    {
      key: "razonSocialLibrador",
      header: `${t("documentos.validar.tab.headerCompanyName")}`,
      field: "razonSocialLibrador",
    },
    {
      key: "nifLibrador",
      header: `${t("documentos.validar.tab.headerNif")}`,
      field: "nifLibrador",
    },
    {
      key: "fechaEmision",
      header: `${t("documentos.validar.tab.headerDateEmision")}`,
      field: "fechaEmision",
      body: ({ fechaEmision }: DocumentoComercialValidacionDtoProps) =>
        fechaEmision ? frontendDateFormat(new Date(fechaEmision)) : "-",
    },
    {
      key: "importe",
      header: `${t("documentos.validar.tab.headerTax")}`,
      field: "importe",
      bodyClassName: "!tw-text-end",
      alignCol: "right",
      body: ({ importe }: DocumentoComercialValidacionDtoProps) =>
        frontendCurrency(importe ?? 0),
    },
    {
      key: "opciones",
      style: { width: "4%" },
      className: "!tw-p-2",
      bodyClassName: "!tw-w-auto tw-flex tw-justify-end",
      body: (rowData: DocumentoComercialValidacionDtoProps) => {
        if (!rowData.id) return
        return (
          <div
            onClick={() => {
              setRowSelected(rowData.id)
            }}
            className='flex items-center justify-center cursor-pointer tw-h-9 tw-w-9 tw-bg-white tw-rounded-md tw-shadow-md'
          >
            <FontAwesomeIcon icon={faEye} />
          </div>
        )
      },
    },
  ]
  return columns
}
